/**
 * belfastpilates-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SwapBean', 'model/UserBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SwapBean'), require('./UserBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesProductionappspotcom) {
      root.BelfastpilatesProductionappspotcom = {};
    }
    root.BelfastpilatesProductionappspotcom.SwapResponse = factory(root.BelfastpilatesProductionappspotcom.ApiClient, root.BelfastpilatesProductionappspotcom.SwapBean, root.BelfastpilatesProductionappspotcom.UserBean);
  }
}(this, function(ApiClient, SwapBean, UserBean) {
  'use strict';




  /**
   * The SwapResponse model module.
   * @module model/SwapResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>SwapResponse</code>.
   * @alias module:model/SwapResponse
   * @class
   */
  var exports = function() {
    var _this = this;




























  };

  /**
   * Constructs a <code>SwapResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SwapResponse} obj Optional instance to populate.
   * @return {module:model/SwapResponse} The populated <code>SwapResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('availableForSwap')) {
        obj['availableForSwap'] = ApiClient.convertToType(data['availableForSwap'], 'Boolean');
      }
      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('cost')) {
        obj['cost'] = ApiClient.convertToType(data['cost'], 'String');
      }
      if (data.hasOwnProperty('costToDisplay')) {
        obj['costToDisplay'] = ApiClient.convertToType(data['costToDisplay'], 'String');
      }
      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('endTime')) {
        obj['endTime'] = ApiClient.convertToType(data['endTime'], 'String');
      }
      if (data.hasOwnProperty('errorCode')) {
        obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('instructorDetails')) {
        obj['instructorDetails'] = ApiClient.convertToType(data['instructorDetails'], [UserBean]);
      }
      if (data.hasOwnProperty('instructorIds')) {
        obj['instructorIds'] = ApiClient.convertToType(data['instructorIds'], ['String']);
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('level')) {
        obj['level'] = ApiClient.convertToType(data['level'], 'String');
      }
      if (data.hasOwnProperty('origBookId')) {
        obj['origBookId'] = ApiClient.convertToType(data['origBookId'], 'String');
      }
      if (data.hasOwnProperty('paid')) {
        obj['paid'] = ApiClient.convertToType(data['paid'], 'Boolean');
      }
      if (data.hasOwnProperty('paymentReference')) {
        obj['paymentReference'] = ApiClient.convertToType(data['paymentReference'], 'String');
      }
      if (data.hasOwnProperty('responseMsg')) {
        obj['responseMsg'] = ApiClient.convertToType(data['responseMsg'], 'String');
      }
      if (data.hasOwnProperty('serviceId')) {
        obj['serviceId'] = ApiClient.convertToType(data['serviceId'], 'String');
      }
      if (data.hasOwnProperty('sessionDate')) {
        obj['sessionDate'] = ApiClient.convertToType(data['sessionDate'], 'Date');
      }
      if (data.hasOwnProperty('sessionDateToDisplay')) {
        obj['sessionDateToDisplay'] = ApiClient.convertToType(data['sessionDateToDisplay'], 'String');
      }
      if (data.hasOwnProperty('setId')) {
        obj['setId'] = ApiClient.convertToType(data['setId'], 'String');
      }
      if (data.hasOwnProperty('startTime')) {
        obj['startTime'] = ApiClient.convertToType(data['startTime'], 'String');
      }
      if (data.hasOwnProperty('swapList')) {
        obj['swapList'] = ApiClient.convertToType(data['swapList'], [SwapBean]);
      }
      if (data.hasOwnProperty('swappedBookId')) {
        obj['swappedBookId'] = ApiClient.convertToType(data['swappedBookId'], 'String');
      }
      if (data.hasOwnProperty('totalNumberOfSwapSpacesAvailable')) {
        obj['totalNumberOfSwapSpacesAvailable'] = ApiClient.convertToType(data['totalNumberOfSwapSpacesAvailable'], 'Number');
      }
      if (data.hasOwnProperty('userDetails')) {
        obj['userDetails'] = UserBean.constructFromObject(data['userDetails']);
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
      if (data.hasOwnProperty('year')) {
        obj['year'] = ApiClient.convertToType(data['year'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} availableForSwap
   */
  exports.prototype['availableForSwap'] = undefined;
  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {String} cost
   */
  exports.prototype['cost'] = undefined;
  /**
   * @member {String} costToDisplay
   */
  exports.prototype['costToDisplay'] = undefined;
  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {String} endTime
   */
  exports.prototype['endTime'] = undefined;
  /**
   * @member {Number} errorCode
   */
  exports.prototype['errorCode'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {Array.<module:model/UserBean>} instructorDetails
   */
  exports.prototype['instructorDetails'] = undefined;
  /**
   * @member {Array.<String>} instructorIds
   */
  exports.prototype['instructorIds'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {String} level
   */
  exports.prototype['level'] = undefined;
  /**
   * @member {String} origBookId
   */
  exports.prototype['origBookId'] = undefined;
  /**
   * @member {Boolean} paid
   */
  exports.prototype['paid'] = undefined;
  /**
   * @member {String} paymentReference
   */
  exports.prototype['paymentReference'] = undefined;
  /**
   * @member {String} responseMsg
   */
  exports.prototype['responseMsg'] = undefined;
  /**
   * @member {String} serviceId
   */
  exports.prototype['serviceId'] = undefined;
  /**
   * @member {Date} sessionDate
   */
  exports.prototype['sessionDate'] = undefined;
  /**
   * @member {String} sessionDateToDisplay
   */
  exports.prototype['sessionDateToDisplay'] = undefined;
  /**
   * @member {String} setId
   */
  exports.prototype['setId'] = undefined;
  /**
   * @member {String} startTime
   */
  exports.prototype['startTime'] = undefined;
  /**
   * @member {Array.<module:model/SwapBean>} swapList
   */
  exports.prototype['swapList'] = undefined;
  /**
   * @member {String} swappedBookId
   */
  exports.prototype['swappedBookId'] = undefined;
  /**
   * @member {Number} totalNumberOfSwapSpacesAvailable
   */
  exports.prototype['totalNumberOfSwapSpacesAvailable'] = undefined;
  /**
   * @member {module:model/UserBean} userDetails
   */
  exports.prototype['userDetails'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * @member {String} year
   */
  exports.prototype['year'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/SwapResponse.js